import React from 'react';
import { Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme();

theme.typography.body1 = {
  fontSize: '1.125rem',
};

const Typography18 = (props) => {
  const { style, classes } = props;

  return (
    <ThemeProvider theme={theme}>
      <Typography variant="body1" style={style} className={classes} {...props}>
        {props.children}
      </Typography>
    </ThemeProvider>
  );
};

export default Typography18;
